import { isEqual } from "es-toolkit";
import { createContext, useContext, useMemo, useRef } from "react";

import { RequestorIdentity } from "../types/requestorIdentity.ts";

const APIRequestorIdentityContext = createContext<RequestorIdentity | null>(
  null,
);

export const useAPIRequestorIdentity = () => {
  const context = useContext(APIRequestorIdentityContext);

  if (!context) {
    throw new Error(
      "useAPIRequestorIdentity must be used within a APIRequestorIdentityProvider",
    );
  }
  return context;
};

type Props = {
  children: React.ReactNode;
  requestorIdentity: RequestorIdentity;
};

export function APIRequestorIdentityProvider({
  children,
  requestorIdentity,
}: Props) {
  const ref = useRef<RequestorIdentity | null>(null);

  const value = useMemo(() => {
    // A lot of time we get a new requestorIdentity object with the same values
    // Deep comparison here makes sense to avoid unwanted useEffect calls
    if (false === isEqual(requestorIdentity, ref.current)) {
      ref.current = requestorIdentity;
    }

    return ref.current;
  }, [requestorIdentity]);

  return (
    <APIRequestorIdentityContext.Provider value={value}>
      {children}
    </APIRequestorIdentityContext.Provider>
  );
}
